import api from '@api';
import { WebhookDeliveryGridMode } from 'skladon-types';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    getWebhookDeliveriesGridFetchSuccess,
    getWebhookDeliveriesGridFetchFailure,
    retryWebhookDeliveryFetchSuccess,
    retryWebhookDeliveryFetchFailure,
    getWebhookDeliveriesGridFetch as getWebhookDeliveriesGridFetchAction,
} from './reducer';
import { getWebhookDeliveryDetailFetch } from '../webhookDeliveryDetail/reducer';
import { WebhookDeliveriesGridResType, GetWebhookDeliveriesGridCallPayloadType } from 'src/types/webhookDeliveriesGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';
import translate from '@translate';

export const WEBHOOK_DELIVERIES_GRID_URL = 'api/secure/webhooks/deliveries/grid';

const getWebhookDeliveriesGridFetchRequest = async (payload: GetWebhookDeliveriesGridCallPayloadType) => {
    const res = await api('post', WEBHOOK_DELIVERIES_GRID_URL, {
        ...payload.params,
        mode: payload.mode,
    });
    return res.data.data;
};

function* getWebhookDeliveriesGridFetch(action: {
    type: string;
    payload?: GetWebhookDeliveriesGridCallPayloadType;
}) {
    try {
        let payloadData: GetWebhookDeliveriesGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const request: GridRequestType | undefined = yield select(
                (state: RootStoreType) => state.webhookDeliveriesGrid.data?.request
            );
            const mode: WebhookDeliveryGridMode = yield select(
                (state: RootStoreType) => state.webhookDeliveriesGrid.mode
            );
            if (request) {
                payloadData = {
                    params: request,
                    mode,
                };
            }
        }
        if (payloadData) {
            const response: WebhookDeliveriesGridResType = yield call((): any =>
                getWebhookDeliveriesGridFetchRequest(payloadData as GetWebhookDeliveriesGridCallPayloadType)
            );
            yield put(getWebhookDeliveriesGridFetchSuccess(response));
        } else {
            yield put(getWebhookDeliveriesGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getWebhookDeliveriesGridFetchFailure({ error }));
    }
}

export function* getWebhookDeliveriesGridFetchWatch() {
    yield takeEvery('webhookDeliveriesGrid/getWebhookDeliveriesGridFetch', getWebhookDeliveriesGridFetch);
}

const retryWebhookDeliveryFetchRequest = async (eventId: string) => {
    const res = await api('post', `api/secure/webhooks/deliveries/${eventId}/retry`);
    return res.data;
};

function* retryWebhookDeliveryFetch(action: { type: string; payload: string }) {
    try {
        yield call((): any => retryWebhookDeliveryFetchRequest(action.payload));
        yield put(
            retryWebhookDeliveryFetchSuccess({
                messageSuccess: { title: translate('webhookRecords.message.retryQueued') },
            })
        );
        yield put(getWebhookDeliveriesGridFetchAction());
        yield put(getWebhookDeliveryDetailFetch(action.payload));
    } catch (error) {
        yield put(retryWebhookDeliveryFetchFailure({ error }));
    }
}

export function* retryWebhookDeliveryFetchWatch() {
    yield takeEvery('webhookDeliveriesGrid/retryWebhookDeliveryFetch', retryWebhookDeliveryFetch);
}
